import * as React from 'react';

const Lock16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 9a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 8 9"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 5.527h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7.527a2 2 0 0 1 2-2h1.001V4A4 4 0 1 1 12 4zM10.5 4a2.5 2.5 0 1 0-4.999 0v1.5H10.5zM13 7.027H3a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.527a.5.5 0 0 0-.5-.5"
  }
));
Lock16.Size = 16;
Lock16.Title = "Lock";

export { Lock16 as default };
